export const contactBox={
    minHeight: "100vh",
    width: "80%",
    position: "absolute",
    top: "6rem",
    left: "20%",
    // backgroundColor: "#1F1F1F",
    backgroundColor: "#FCF8F2",
    index:1,
    
}
export const textWhite ={
    color:"black"
}
export const textRed = {
    color: 'orange', // Make sure to use quotes around the color value
    textAlign: 'center',
    boxSizing: 'border-box',
    textDecoration: 'none',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '1.5', // Use a unitless number or adjust according to your design
    textDecorationLine: 'underline',
    marginLeft:7
  };
  